/**
 * Ca_instant.js v3.2 - Hardened Zero-Trust Edition
 * Focus: Security alignment, Resource Shielding & Duplication Prevention
 */
(function () {
  'use strict';
  if (window.__CaInstantOptimized) return;
  window.__CaInstantOptimized = true;

  const config = {
    hoverDelay: 85, // Slightly increased to minimize accidental bot-hover fetches
    // Strict Regex pattern covering standard, localized, and parameter checkouts/carts
    excludedRegex: /\/(cart|checkout|checkouts|account|search|admin|challenge|apps)\b|[\?#]/i
  };

  // 1. SAFE PREFETCH MANAGER
  const quickPrefetch = (url) => {
    // Stop fetches on slow connections or if SpeculationRules API is already handling it
    if (navigator.connection?.saveData || /2g|slow-2g/.test(navigator.connection?.effectiveType)) return;
    if (HTMLScriptElement.supports && HTMLScriptElement.supports('speculationrules')) return;
    if (document.querySelector(`link[href="${url}"]`)) return;

    const link = document.createElement('link');
    link.rel = 'prefetch';
    link.href = url;
    link.as = 'document';
    document.head.appendChild(link);
    
    // Immediate DOM cleanup after injection
    setTimeout(() => link.remove(), 2000);
  };

  // 2. STABLE CLS SHIELD & LAZY LOADING (GPU Safe)
  const fastLazy = () => {
    const images = document.querySelectorAll('img[data-src]:not([loading])');
    
    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          const img = entry.target;
          
          if (!img.getAttribute('width') && !img.style.height) {
            img.style.minHeight = '150px'; 
          }
          
          img.src = img.dataset.src;
          img.removeAttribute('data-src');
          img.setAttribute('decoding', 'async');
          
          // REMOVED will-change to prevent browser memory execution leaks
          observer.unobserve(img);
        }
      });
    }, { rootMargin: '200px' });

    images.forEach(img => observer.observe(img));
  };

  // 3. CPU OPTIMIZED DELEGATION WITH BOUNDARY CHECKING
  const initListeners = () => {
    let timer;
    document.addEventListener('mouseover', (e) => {
      const a = e.target.closest('a');
      if (!a || !a.href) return;
      
      const url = a.href;
      
      // Strict security matching against localized subfolders and root URLs
      if (!url.startsWith(window.location.origin)) return;
      
      const urlPath = url.replace(window.location.origin, '');
      if (config.excludedRegex.test(urlPath)) return;

      clearTimeout(timer);
      timer = setTimeout(() => quickPrefetch(url), config.hoverDelay);
    }, { passive: true });
  };

  const boot = () => {
    fastLazy();
    initListeners();
  };

  if ('requestIdleCallback' in window) {
    requestIdleCallback(boot);
  } else {
    setTimeout(boot, 30);
  }
})();
